<div class="incarnation-cross" [class.mirrored]="isMirrored()">
  @if (showTransformationArrow()) {
    <hd-transformation-arrow
      class="transformation-arrow-slot"
      [tone]="motivationTone()!"
      [side]="side()"
      [category]="phsCategory()"
      [colorConfig]="colorConfig()"
      [showHdKeynotes]="showHdKeynotes()"
      [relatedGates]="furnishingGates()"
      (phsBlockClicked)="onPhsBlockClicked($event)"
    ></hd-transformation-arrow>
  }

  @if (earthBlock(); as earth) {
    <hd-planet-activation-block
      class="earth-block"
      [activation]="earth.activation"
      [displayConfig]="earth.displayConfig"
      [colorConfig]="colorConfig()"
      [isDefined]="earth.isDefined"
      [geneKeysLabel]="earth.geneKeysLabel"
      [showHdKeynotes]="showHdKeynotes()"
      [baseHoverTargetGate]="earthBaseHoverGate()"
      [density]="density()"
      variant="cross"
      (blockClicked)="blockClicked.emit($event)"
    ></hd-planet-activation-block>
  }

  @if (sunBlock(); as sun) {
    <hd-planet-activation-block
      class="sun-block"
      [activation]="sun.activation"
      [displayConfig]="sun.displayConfig"
      [colorConfig]="colorConfig()"
      [isDefined]="sun.isDefined"
      [geneKeysLabel]="sun.geneKeysLabel"
      [showHdKeynotes]="showHdKeynotes()"
      [baseHoverTargetGate]="sunBaseHoverGate()"
      [density]="density()"
      variant="cross"
      (blockClicked)="blockClicked.emit($event)"
    ></hd-planet-activation-block>
  }

  @if (motivationColor() !== null && motivationTone() !== null) {
    <hd-color-tone-block
      class="motivation-block"
      [colorNumber]="motivationColor()!"
      [toneNumber]="motivationTone()!"
      [side]="side()"
      [colorConfig]="colorConfig()"
      [colorIcon]="phsColorIcon()"
      [cognitionIcon]="phsCognitionIcon()"
      [colorTooltip]="phsColorTooltip()"
      [cognitionTooltip]="phsCognitionTooltip()"
      [variantIcon]="phsVariantIcon()"
      [variantTooltip]="phsVariantTooltip()"
      [mode]="visualizationMode()"
      [density]="density()"
      [variantName]="phsVariantName()"
      [cognitionName]="phsCognitionName()"
      [relatedGates]="furnishingGates()"
      (phsBlockClicked)="onPhsBlockClicked($event)"
    ></hd-color-tone-block>
  }
</div>
